import { t, Trans } from "@lingui/macro";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Typography } from "@mui/material";
import { MatesSelect, MatesTextField, withUseFormHook } from "@sinossi/mates-react-library";
import React from "react";
import { UseFormReturn } from "react-hook-form";
import * as Yup from "yup";
import { ListLandlordsProjection } from "../../../models/landlord";
import { AssetService } from "../../../services/asset.service";
import Icon from "@mdi/react";
import { mdiPencil, mdiFileUpload, mdiFileDocumentPlus, mdiDatabaseImport } from "@mdi/js";
import { CustomDropzoneUploadDocument } from "../../brand/customDropzoneUploadDocument";

const CreateAssetModalSchema = Yup.object().shape({
    address: Yup.string().required('Il campo è obbligatorio'),
});

interface CreateAssetModalProps extends UseFormReturn {
    closeModal: () => void,
    submitForm: (values: any) => void,
    landlordList: ListLandlordsProjection[],
    isCreatingAccountLandlord?: boolean
}

interface CreateAssetModalState {
    selectedOption: "manual" | "base" | "advanced" | "storebook" | null;
    file: File | null;
    isUploading: boolean;
    uploadError: string | null;
}


class CreateAssetModal extends React.Component<CreateAssetModalProps, CreateAssetModalState> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedOption: null,
            file: null,
            isUploading: false,
            uploadError: null
        };
    }

    private submitForm = (values: any) => {
        this.props.submitForm(values)
    }

    private selectOption = (option: "manual" | "base" | "advanced" | "storebook") => {
        this.setState({ selectedOption: option });
    }

    private handleFileChange = (file: File) => {
        this.setState({ file, uploadError: null });
    }

    private uploadFile = () => {
        const { file, selectedOption } = this.state;
        
        if (!file) {
            this.setState({ uploadError: "Seleziona un file da caricare" });
            return;
        }

        this.setState({ isUploading: true, uploadError: null });

        const formData = new FormData();
        formData.append("file", file);

        const onSuccess = () => {
            this.setState({ isUploading: false });
            this.props.closeModal();
        };

        const onError = (error: any) => {
            console.error("Errore durante il caricamento del file:", error);
            this.setState({ 
                isUploading: false,
                uploadError: "Si è verificato un errore durante il caricamento del file. Riprova." 
            });
        };

        if (selectedOption === "base") {
            AssetService.uploadImmobiliareBaseData(formData, onSuccess, onError);
        } else if (selectedOption === "advanced") {
            AssetService.uploadImmobiliareAdvancedData(formData, onSuccess, onError);
        } else if (selectedOption === "storebook") {
            AssetService.uploadStorebookCsv(formData, onSuccess, onError);
        }
    }

    private renderOptionButtons = () => {
        const buttonStyle = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: 160,
            width: '100%',
            borderRadius: 2,
            transition: 'all 0.3s',
            textTransform: 'none',
            padding: 2,
            '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.08)',
                transform: 'translateY(-4px)',
                boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
            }
        };

        return (
            <Grid container spacing={3} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={4}>
                    <Paper 
                        elevation={2} 
                        sx={{ 
                            borderRadius: 2, 
                            overflow: 'hidden',
                            '&:hover': {
                                boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                            }
                        }}
                    >
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={() => this.selectOption("manual")}
                            sx={buttonStyle}
                        >
                            <Icon 
                                path={mdiPencil} 
                                size={2} 
                                color="#1976d2" 
                                style={{ marginBottom: '16px' }}
                            />
                            <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                                <Trans id="cam-manual-input">Inserimento manuale</Trans>
                            </Typography>
                        </Button>
                    </Paper>
                </Grid>
                {/* <Grid item xs={12} sm={4}>
                    <Paper
                        elevation={2}
                        sx={{
                            borderRadius: 2,
                            overflow: 'hidden',
                            '&:hover': {
                                boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                            }
                        }}
                    >
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={() => this.selectOption("base")}
                            sx={buttonStyle}
                        >
                            <Icon
                                path={mdiFileUpload}
                                size={2}
                                color="#1976d2"
                                style={{ marginBottom: '16px' }}
                            />
                            <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                                <Trans id="cam-base-file">Carica file base</Trans>
                            </Typography>
                        </Button>
                    </Paper>
                </Grid> */}
                {/* <Grid item xs={12} sm={4}>
                    <Paper
                        elevation={2}
                        sx={{
                            borderRadius: 2,
                            overflow: 'hidden',
                            '&:hover': {
                                boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                            }
                        }}
                    >
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={() => this.selectOption("advanced")}
                            sx={buttonStyle}
                        >
                            <Icon
                                path={mdiFileDocumentPlus}
                                size={2}
                                color="#1976d2"
                                style={{ marginBottom: '16px' }}
                            />
                            <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                                <Trans id="cam-advanced-file">Carica file avanzato</Trans>
                            </Typography>
                        </Button>
                    </Paper>
                </Grid> */}
                <Grid item xs={12} sm={4}>
                    <Paper
                        elevation={2}
                        sx={{
                            borderRadius: 2,
                            overflow: 'hidden',
                            '&:hover': {
                                boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                            }
                        }}
                    >
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={() => this.selectOption("storebook")}
                            sx={buttonStyle}
                        >
                            <Icon
                                path={mdiDatabaseImport}
                                size={2}
                                color="#1976d2"
                                style={{ marginBottom: '16px' }}
                            />
                            <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                                <Trans id="cam-storebook-file">Carica Storebook CSV</Trans>
                            </Typography>
                        </Button>
                    </Paper>
                </Grid>
            </Grid>
        );
    }

    private renderManualForm = () => {
        return (
            <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                <DialogContent>
                    {(this.props.isCreatingAccountLandlord === false) && <>
                        <Typography sx={{ pb: 1 }} >
                            <Trans id="cam-owner-label">Inserisci il proprietario</Trans>
                        </Typography>
                        <MatesSelect
                            variant={"outlined"}
                            label={t({
                                id: "cam-asset-owner",
                                message: "Proprietario",
                            })}
                            name="owner"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        >
                            {this.props.landlordList.map((landlord) => (
                                <option value={landlord.id} key={landlord.id}>{landlord.name + " " + landlord.surname}</option>
                            ))}
                        </MatesSelect>
                    </>}
                    <Typography sx={{ pt: 2, pb: 1 }}>
                        <Trans id="cam-address-label">Inserisci l'indirizzo</Trans>
                    </Typography>
                    <MatesTextField
                        variant={"outlined"}
                        label={t({
                            id: "cam-asset-address",
                            message: "Indirizzo",
                        })}
                        name="address"
                        control={this.props.control}
                        trigger={this.props.trigger}
                        formState={this.props.formState}
                    />
                </DialogContent>
                <DialogActions sx={{ pr: 2 }}>
                    <Button onClick={this.props.closeModal}
                        variant={"contained"}
                        color="neutral"
                        sx={{
                            textTransform: "none",
                            mr: 1,
                            width: 100
                        }}
                        disableElevation>
                        <Trans id={"cam-close-button"}>
                            Annulla
                        </Trans>
                    </Button>
                    <Button type="submit"
                        variant="contained"
                        sx={{
                            backgroundColor: 'secondary.main',
                            color: 'white',
                            mr: 1,
                            textTransform: "none",
                            width: 100
                        }}
                    >
                        <Trans id={"fm-confirm-button"}>Conferma</Trans>
                    </Button>
                </DialogActions>
            </form>
        );
    }

    private renderFileUploadForm = () => {
        const { isUploading, uploadError } = this.state;

        return (
            <>
                <DialogContent>
                    <CustomDropzoneUploadDocument
                        callback={this.handleFileChange}
                        text="cam-select-csv-file"
                    />

                    {uploadError && (
                        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                            {uploadError}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions sx={{ pr: 2 }}>
                    <Button 
                        onClick={this.props.closeModal}
                        variant={"contained"}
                        color="neutral"
                        sx={{
                            textTransform: "none",
                            mr: 1,
                            width: 100
                        }}
                        disabled={isUploading}
                        disableElevation
                    >
                        <Trans id={"cam-close-button"}>
                            Annulla
                        </Trans>
                    </Button>
                    <Button 
                        onClick={this.uploadFile}
                        variant="contained"
                        disabled={isUploading || !this.state.file}
                        sx={{
                            backgroundColor: 'secondary.main',
                            color: 'white',
                            mr: 1,
                            textTransform: "none",
                            width: 100
                        }}
                    >
                        <Trans id={"fm-uploading-button"}>
                            {isUploading ? "Caricamento..." : "Carica"}
                        </Trans>
                    </Button>
                </DialogActions>
            </>
        );
    }

    render() {
        const { selectedOption } = this.state;
        
        return (
            <Dialog
                open={true}
                onClose={() => this.props.closeModal()}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    <Typography variant="h5">
                        <Trans id="cam-modal-title">Aggiungi immobile</Trans>
                    </Typography>
                </DialogTitle>
                
                {selectedOption === null && (
                    <>
                        <DialogContent>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                <Trans id="cam-select-option">
                                    Seleziona una modalità di inserimento
                                </Trans>
                            </Typography>
                            {this.renderOptionButtons()}
                        </DialogContent>
                        <DialogActions sx={{ pr: 2 }}>
                            <Button 
                                onClick={this.props.closeModal}
                                variant={"contained"}
                                color="neutral"
                                sx={{
                                    textTransform: "none",
                                    mr: 1,
                                    width: 100
                                }}
                                disableElevation
                            >
                                <Trans id={"cam-close-button"}>
                                    Annulla
                                </Trans>
                            </Button>
                        </DialogActions>
                    </>
                )}
                
                {selectedOption === "manual" && this.renderManualForm()}
                
                {(selectedOption === "base" || selectedOption === "advanced" || selectedOption === "storebook") &&
                    this.renderFileUploadForm()
                }
            </Dialog>
        );
    }

}

export default withUseFormHook<{}>(CreateAssetModal, CreateAssetModalSchema, {});
